import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import {
	closeChangelogOnStammdatenNavigateSaga,
	closeChangelogSaga,
	openChangelogSaga,
	reloadChangelogSaga
} from "./sagas";
import { ChangelogDataProvider } from "./dataProvider";
import { ChangelogFormEngine } from "./components/ChangelogFormEngine";

const changelogModule = (): Module => ({
	id: "changelogModule",
	sagas: () => [openChangelogSaga, reloadChangelogSaga, closeChangelogSaga, closeChangelogOnStammdatenNavigateSaga],
	dataProviders: () => [ChangelogDataProvider],
	views: () => viewComponentProvider
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	ChangelogFormEngine: ChangelogFormEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default changelogModule;
